/* unplugin-vue-components disabled */import script from "./AsideView.vue?vue&type=script&setup=true&lang=js"
export * from "./AsideView.vue?vue&type=script&setup=true&lang=js"

import "./AsideView.vue?vue&type=style&index=0&id=4d4db11d&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d4db11d"]])

export default __exports__